import React from 'react';

import { View } from 'react-native';

import { OPComponent, I18n, Utils, FormInput, Navigation, FormHelpers } from '../components';

import { THEME } from '../../constants/styles';

export default class ResidentForm extends OPComponent {
  constructor(props) {
    super(props);

    this.nameInputRef = React.createRef();
  }

  validate = () => {
    const fieldsToValidate = [this.nameInputRef];
    return FormHelpers.validateFields(
      fieldsToValidate.map((fieldRef) => fieldRef.current).filter((ref) => !!ref)
    );
  };

  handleChangeName = (text) => {
    this.props.handleChangeValue({
      name: text,
    });
  };

  render() {
    const props = this.props;
    const isUpdate = !!props.caseId;

    // if we're updating an existing case all of the fields are included in the patient form
    if (isUpdate) {
      return null;
    }

    return (
      <View style={THEME.inputsContainer}>
        <FormInput
          ref={this.nameInputRef}
          required={true}
          editable={props.editable && !props.hasPatientObj}
          value={props.name}
          label={I18n.aec('case.residentName')}
          tipText={I18n.aec('case.residentNameTip')}
          onChangeText={this.handleChangeName}
        />
      </View>
    );
  }
}
